import React from 'react';

import Question from '../elements/question';
import Feedback from '../elements/feedback';
import {SubsidieBox, WarningBox} from '../elements/infoboxes'
import state from '../zviz3/state';
import { ConnectState } from '../zviz3/Connect';
import { checkConditions } from '../helpers/conditions';
import Icon from '../elements/icon';


const questions = [
    {
        name: 'g1',
        question: 'Heeft u maatwerkadviesrapport laten opstellen na 15 augustus 2019?',
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [ 
            {variable: 'f', value: true, type: 'equal'}
        ]
    },
    {
        name: 'g2',
        question: 'Heeft u subsidie ontvangen voor het maatwerkadviesrapport uit een andere subsidieregeling of vanuit gemeente of provincie?',
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'g1', value: true, type: 'equal'}
        ]
    }
]

const condRapport = [
    {variable: 'g2', value: false, type: 'equal'}
];

const concludedQuestions = [
    {variable: 'g1', value: false, type: 'equal'},
    {variable: 'g2', value: null, type: 'not_equal'}
];

export const getSubsidies = function(){
    let text = [];
    if(checkConditions(condRapport)){
        text.push("Subsidie voor een maatwerkadviesrapport à € 150");
    }
    return text;
}

const feedback = [
    {
        content: () => ( <SubsidieBox text={getSubsidies()} /> ),
        name: 'g',
        value: true,
        conditions: [
            {type: 'and', conditions: [
                // conditions to match to get the subsidy
                {type: 'group', conditions: [...condRapport]},

                // set of conditions to identify that the question has concluded
                {type: 'group', conditions: concludedQuestions},
            ]}
        ]    
    },

    {
        content: <WarningBox text="U komt niet in aanmerking voor subsidie voor een maatwerkrapport" />,
        name: 'g',
        value: true,
        conditions: [
            {type: 'and', conditions: [
                // condition the question has concluded
                {type: 'group', conditions: concludedQuestions},

                // condition, we do not have a success
                {type: 'nor', conditions: [...condRapport]}
            ]},
        ]    
    },
];

function SectionG(props){

    if(state.get('answers.f') === true){
        return <div className="seehi_section">
            <h2 className="seehi_iconHeader"><Icon type="advies" />Maatwerk&shy;advies&shy;rapport</h2>
            <p>Misschien heeft u ook een maatwerk&shy;advies&shy;rapport laten opstellen, u kunt hier dan nog een extra subsidie voor ontvangen.</p>

            {questions.map((props, i) => ( <Question key={i} {...props} /> ))}
        
            {feedback.map((props, i) => ( <Feedback key={i} {...props} /> ))}
            
        </div>;
    }

    return '';
}

export default ConnectState(SectionG, 'answers.f');



// WEBPACK FOOTER //
// ./src/sections/g.js